export function shouldRenderDesktopToasts({
  isDesktop,
  myDisplayId,
  activeDisplayId,
  expandedDisplayId,
  knownDisplayIds,
}: {
  isDesktop: boolean;
  myDisplayId: number | null;
  activeDisplayId: number | null;
  /** While a card is open the stack stays on its display (spec §4.5). */
  expandedDisplayId: number | null;
  /** Displays currently known to exist. A stale `expandedDisplayId` (its
   *  display unplugged, or geometry never published in this window) is a
   *  pure fallback to "nothing is expanded" rather than hiding the stack
   *  everywhere — it never writes to any store. */
  knownDisplayIds: readonly number[];
}): boolean {
  if (!isDesktop) return true;
  if (myDisplayId === null) return false;
  const expandedIsKnown = expandedDisplayId !== null && knownDisplayIds.includes(expandedDisplayId);
  if (expandedIsKnown) return myDisplayId === expandedDisplayId;
  return activeDisplayId === myDisplayId;
}
